import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";
import { bidTypeOptions, categoryOptions, stateOptions } from "./types";

export const fields: FilterFieldConfig[] = [
    { key: "opportunityName", label: "Opportunity Name", type: "text", default: "" },
    { key: "organizationId", label: "Organization", type: "asyncSelect", default: "",
        fileName: "common/searchOrganization.php",
        placeholder: "Search organization…",
        isMulti: false,
    },
   
    { key: "probability", label: "Probability", type: "range", default: "",
        inputType: "number"
    },
	{ key: "bidAmount", label: "Bid Amount", type: "range", default: "",
        inputType: "number"
    },
	{ key: "bidType", label: "Bid Type", type: "select", default: "", options: bidTypeOptions.map(v => ({label: v, value: v})) },
	{ key: "category", label: "Category", type: "select", default: "", options: categoryOptions.map(v => ({label: v, value: v})) },
	{ key: "state", label: "State", type: "select", default: "",  options: stateOptions.map(v => ({label: v, value: v})) },
	{ key: "location", label: "Location", type: "text", default: "" },
	{ key: "actualCloseDate", label: "actual Close Date", type: "range", default: "", 
        inputType: "date" 
    },
	// { key: "projectId", label: "Project Id" },
	{ key: "contactId", label: "Contact", type: "asyncSelect", default: "",
        fileName: "common/searchContact.php",
        placeholder: "Search contact…",
        isMulti: false
    },
    { key: "userResponsibleId", label: "User Responsible", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search user…",
        isMulti: false,
    },
    { key: "background", label: "Background", type: "text", default: "" },
    { key: "creatorId", label: "Created By", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search user…",
        isMulti: false,
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search user…", 
        isMulti: false, 
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no",
        options: [
        { value: "no", label: "Valid" },
        { value: "yes", label: "Void" },
        { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function OpportunityFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}
